import { PERMISSIONS } from '../constants/permissions';
import type { AttendanceCorrectionModuleCapabilities } from '../types/attendanceCorrection';
import { hasPermission } from '../utils/permissions';

/**
 * Manual attendance correction capabilities.
 *
 * Mounted (arkhrmsapi attendance correction routes):
 * - GET /attendance/corrections/history
 * - GET /attendance/corrections/:id
 * - POST /attendance/corrections
 * - POST /attendance/corrections/:id/cancel|approve|reject
 */
export const ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES = {
  history: true,
  details: true,
  apply: true,
  cancel: true,
  adminRequests: true,
  correctionApproval: true,
  approveAction: true,
  rejectAction: true,
} as const;

export function getAttendanceCorrectionModuleCapabilities(
  permissions: readonly string[],
): AttendanceCorrectionModuleCapabilities {
  const canCorrect = hasPermission(permissions, PERMISSIONS.ATTENDANCE_CORRECT);
  const canView = hasPermission(permissions, PERMISSIONS.ATTENDANCE_VIEW);
  const canApprove = hasPermission(permissions, PERMISSIONS.ATTENDANCE_APPROVE);
  const isAdmin = hasPermission(permissions, PERMISSIONS.EMPLOYEE_VIEW);
  return {
    canViewHistory: canView && ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES.history,
    canViewDetails: canView && ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES.details,
    canApply:
      canCorrect && ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES.apply && !isAdmin,
    canCancel: canCorrect && ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES.cancel,
    canViewAdminRequests:
      canApprove && ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES.adminRequests,
    canAccessCorrectionApproval:
      canApprove && ATTENDANCE_CORRECTION_ROUTE_CAPABILITIES.correctionApproval,
  };
}
